export default "__VITE_ASSET__ffc839a3__"